var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#13CE95",
    d: "M18 6C11.373 6 6 11.373 6 18s5.373 12 12 12c6.628 0 12-5.373 12-12S24.628 6 18 6zm-2.201 18.164l-5.284-5.283 1.761-1.762 3.523 3.523 7.925-7.926 1.761 1.762-9.686 9.686z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessGreen);
export default __webpack_public_path__ + "static/media/success-green.2f9d4a2efadd5be3eb38dcb5407d4006.svg";
export { ForwardRef as ReactComponent };